import apiFetch from "@wordpress/api-fetch";
function getCommonHeaders() {
    return {
        "Content-Type": "application/json",
        "X-WPQT-API-Nonce": window.wpqt.apiNonce,
    };
}
/*
  ==================================================================================================================================================================================================================
  Pipeline requests
  ==================================================================================================================================================================================================================
*/
function getPipelineData(pipelineId) {
    return apiFetch({
        path: `/wpqt/v1/pipelines/${pipelineId}`,
        headers: getCommonHeaders(),
    });
}
function createPipelineRequest(name, description) {
    return apiFetch({
        path: `/wpqt/v1/pipelines`,
        method: "POST",
        data: { name, description },
        headers: getCommonHeaders(),
    });
}
function editPipelineRequest(pipeline) {
    return apiFetch({
        path: `/wpqt/v1/pipelines/${pipeline.id}`,
        method: "PATCH",
        data: {
            name: pipeline.name,
            description: pipeline.description,
            is_primary: pipeline.is_primary,
        },
        headers: getCommonHeaders(),
    });
}
function setPipelinePrimaryRequest(pipelineId) {
    return apiFetch({
        path: `/wpqt/v1/pipelines/${pipelineId}/set-primary`,
        method: "PATCH",
        headers: getCommonHeaders(),
    });
}
function deletePipelineRequest(pipelineId) {
    return apiFetch({
        path: `/wpqt/v1/pipelines/${pipelineId}`,
        method: "DELETE",
        headers: getCommonHeaders(),
    });
}
/*
  ==================================================================================================================================================================================================================
  Task requests
  ==================================================================================================================================================================================================================
*/
function moveTaskRequest(taskId, stageId, order) {
    return apiFetch({
        path: `/wpqt/v1/tasks/${taskId}/move`,
        method: "PATCH",
        data: { stageId, order },
        headers: getCommonHeaders(),
    });
}
function createTaskRequest(stageId, pipelineId, name) {
    return apiFetch({
        path: `/wpqt/v1/tasks`,
        method: "POST",
        data: {
            stageId,
            name,
            pipelineId,
        },
        headers: getCommonHeaders(),
    });
}
function editTaskRequest(task) {
    return apiFetch({
        path: `/wpqt/v1/tasks/${task.id}`,
        method: "PATCH",
        data: {
            id: task.id,
            name: task.name,
            description: task.description,
            freeForAll: task.free_for_all,
        },
        headers: getCommonHeaders(),
    });
}
function deleteTaskRequest(taskId) {
    return apiFetch({
        path: `/wpqt/v1/tasks/${taskId}`,
        method: "DELETE",
        headers: getCommonHeaders(),
    });
}
function archiveTaskRequest(taskId) {
    return apiFetch({
        path: `/wpqt/v1/tasks/${taskId}/archive`,
        method: "PATCH",
        headers: getCommonHeaders(),
    });
}
function restoreArchivedTaskRequest(taskId) {
    return apiFetch({
        path: `/wpqt/v1/tasks/${taskId}/archive-restore`,
        method: "PATCH",
        headers: getCommonHeaders(),
    });
}
function getArchivedTasksRequest() {
    return apiFetch({
        path: `/wpqt/v1/tasks/archived`,
        method: "GET",
        headers: getCommonHeaders(),
    });
}
function markTaskDoneRequest(taskId, done) {
    return apiFetch({
        path: `/wpqt/v1/tasks/${taskId}/done`,
        method: "PATCH",
        data: { done },
        headers: getCommonHeaders(),
    });
}
/*
  ==================================================================================================================================================================================================================
  Comment requests
  ==================================================================================================================================================================================================================
*/
function getComments(typeId, type, isPrivate) {
    const queryParams = new URLSearchParams({
        typeId,
        type,
        isPrivate: isPrivate.toString(),
    }).toString();
    return apiFetch({
        path: `/wpqt/v1/comments?${queryParams}`,
        method: "GET",
        headers: getCommonHeaders(),
    });
}
function addCommentRequest(typeId, type, isPrivate, comment) {
    return apiFetch({
        path: `/wpqt/v1/comments`,
        data: { comment, typeId, type, isPrivate },
        method: "POST",
        headers: getCommonHeaders(),
    });
}
/*
  ==================================================================================================================================================================================================================
  Logs requests
  ==================================================================================================================================================================================================================
*/
function getTaskLogs(taskId) {
    return apiFetch({
        path: `/wpqt/v1/tasks/${taskId}/logs`,
        headers: getCommonHeaders(),
    });
}
function getLogsRequest(typeId, type) {
    const queryParams = new URLSearchParams({
        typeId,
        type,
    });
    return apiFetch({
        path: `/wpqt/v1/logs?${queryParams.toString()}`,
        method: "GET",
        headers: getCommonHeaders(),
    });
}
/*
  ==================================================================================================================================================================================================================
  Stage requests
  ==================================================================================================================================================================================================================
*/
function createNewStageRequest(pipelineId, name, description) {
    return apiFetch({
        path: `/wpqt/v1/stages`,
        method: "POST",
        data: { pipelineId, name, description },
        headers: getCommonHeaders(),
    });
}
function editStageRequest(stage) {
    return apiFetch({
        path: `/wpqt/v1/stages/${stage.id}`,
        method: "PATCH",
        data: { name: stage.name, description: stage.description },
        headers: getCommonHeaders(),
    });
}
function moveStageRequest(stageId, direction) {
    return apiFetch({
        path: `/wpqt/v1/stages/${stageId}/move`,
        method: "PATCH",
        data: { direction },
        headers: getCommonHeaders(),
    });
}
function deleteStageRequest(stageId) {
    return apiFetch({
        path: `/wpqt/v1/stages/${stageId}`,
        method: "DELETE",
        data: { stageId },
        headers: getCommonHeaders(),
    });
}
function archiveStageTasksRequest(stageId) {
    return apiFetch({
        path: `/wpqt/v1/stages/${stageId}/archive-tasks`,
        method: "PATCH",
        headers: getCommonHeaders(),
    });
}
/*
  ==================================================================================================================================================================================================================
  User requests
  ==================================================================================================================================================================================================================
*/
function getUsersRequest() {
    return apiFetch({
        path: `/wpqt/v1/users`,
        method: "GET",
        headers: getCommonHeaders(),
    });
}
function getExtendedUserRequest(userId) {
    return apiFetch({
        path: `/wpqt/v1/users/${userId}/extended`,
        method: "GET",
        headers: getCommonHeaders(),
    });
}
function createUserRequest(name, description) {
    return apiFetch({
        path: `/wpqt/v1/users`,
        method: "POST",
        data: { name, description },
        headers: getCommonHeaders(),
    });
}
function editUserRequest(user) {
    return apiFetch({
        path: `/wpqt/v1/users/${user.id}`,
        method: "PATCH",
        data: { user },
        headers: getCommonHeaders(),
    });
}
function changeUserStatusRequest(userId, status) {
    return apiFetch({
        path: `/wpqt/v1/users/${userId}/status`,
        method: "PATCH",
        data: { status },
        headers: getCommonHeaders(),
    });
}
function assignTaskToUserRequest(userId, taskId) {
    return apiFetch({
        path: `/wpqt/v1/users/${userId}/tasks`,
        method: "POST",
        data: { task_id: taskId },
        headers: getCommonHeaders(),
    });
}
function removeTaskFromUserRequest(userId, taskId) {
    return apiFetch({
        path: `/wpqt/v1/users/${userId}/tasks`,
        method: "DELETE",
        data: { task_id: taskId },
        headers: getCommonHeaders(),
    });
}
function deleteUserRequest(userId) {
    return apiFetch({
        path: `/wpqt/v1/users/${userId}`,
        method: "DELETE",
        headers: getCommonHeaders(),
    });
}
function getUserTasksRequest(userId) {
    return apiFetch({
        path: `/wpqt/v1/users/${userId}/tasks`,
        method: "GET",
        headers: getCommonHeaders(),
    });
}
function resetUserPasswordRequest(userId) {
    return apiFetch({
        path: `/wpqt/v1/users/${userId}/password-reset`,
        method: "PATCH",
        headers: getCommonHeaders(),
    });
}
/*
  ==================================================================================================================================================================================================================
  User session requests
  ==================================================================================================================================================================================================================
*/
function getUserSessionsRequest() {
    return apiFetch({
        path: `/wpqt/v1/users/sessions`,
        method: "GET",
        headers: getCommonHeaders(),
    });
}
function changeUserSessionStatusRequest(sessionId, status) {
    return apiFetch({
        path: `/wpqt/v1/users/sessions/${sessionId}/status`,
        method: "PATCH",
        data: { status },
        headers: getCommonHeaders(),
    });
}
function deleteUserSessionRequest(sessionId) {
    return apiFetch({
        path: `/wpqt/v1/users/sessions/${sessionId}`,
        method: "DELETE",
        headers: getCommonHeaders(),
    });
}
/*
  ==================================================================================================================================================================================================================
  Custom Field requests
  ==================================================================================================================================================================================================================
*/
function getCustomFieldsRequest(entityId, entityType) {
    const queryParams = new URLSearchParams({
        entityId,
        entityType,
    });
    return apiFetch({
        path: `/wpqt/v1/custom-fields?${queryParams.toString()}`,
        method: "GET",
        headers: getCommonHeaders(),
    });
}
function addCustomFieldRequest(entityId, entityType, type, name, description) {
    return apiFetch({
        path: `/wpqt/v1/custom-fields`,
        method: "POST",
        data: { entityId, entityType, type, name, description },
        headers: getCommonHeaders(),
    });
}
function markCustomFieldAsDeletedRequest(customFieldId) {
    return apiFetch({
        path: `/wpqt/v1/custom-fields/${customFieldId}`,
        method: "DELETE",
        headers: getCommonHeaders(),
    });
}
function updateCustomFieldValueRequest(customFieldId, value, entityId, entityType) {
    return apiFetch({
        path: `/wpqt/v1/custom-fields/${customFieldId}/value`,
        method: "PATCH",
        data: { value, entityId: String(entityId), entityType },
        headers: getCommonHeaders(),
    });
}
export { addCommentRequest, addCustomFieldRequest, archiveStageTasksRequest, archiveTaskRequest, assignTaskToUserRequest, changeUserSessionStatusRequest, changeUserStatusRequest, createNewStageRequest, createPipelineRequest, createTaskRequest, createUserRequest, deletePipelineRequest, deleteStageRequest, deleteTaskRequest, deleteUserRequest, deleteUserSessionRequest, editPipelineRequest, editStageRequest, editTaskRequest, editUserRequest, getArchivedTasksRequest, getComments, getCustomFieldsRequest, getExtendedUserRequest, getLogsRequest, getPipelineData, getTaskLogs, getUserSessionsRequest, getUsersRequest, getUserTasksRequest, markCustomFieldAsDeletedRequest, markTaskDoneRequest, moveStageRequest, moveTaskRequest, removeTaskFromUserRequest, resetUserPasswordRequest, restoreArchivedTaskRequest, setPipelinePrimaryRequest, updateCustomFieldValueRequest, };
